<template>
    <!-- BEGIN: Content-->
    <div class="subCategoryList">
      <v-container fluid>

        <v-row>
          <v-col md="12" sm="12" class="d-flex" style="justify-content:space-between">
            <v-breadcrumbs
              :items="breadcrumbs"
              divider="/"
            ></v-breadcrumbs>

            <v-btn
              color="#000000"
              class="white--text"
              depressed
              @click.stop="dialog = true"
            >
              Sub Category
              <v-icon
                right
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>

          </v-col>
        </v-row>

        <v-row>
          <v-col md="12" sm="12">
            <v-card class="card-shadow py-3">
              <v-data-table
                dense
                :headers="fields"
                :items="subcategories"
                class="elevation-0"
                loading="false"
                loading-text="Loading... Please wait"
              >
                <template v-slot:item.#="{ item }">
                  {{ item.created_at }}
                </template>
                <template v-slot:item.name="{ item }">
                  {{ item.name }}
                </template>
                <template v-slot:item.category="{ item }">
                  {{ item.category.category_name }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="edit(item.id)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteq(item.id)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>


      <!-- add user dialog -->
      <v-dialog
        v-model="dialog"
        max-width="600px"
        >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Add SubCategory</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      label="Sub Category Name*"
                      v-model="item.subcategory_name"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    >
                    <v-autocomplete
                      :items="categories"
                      label="Select category"
                      v-model="item.category_id"
                      item-text="category_name"
                      item-value="id"
                      :rules="fieldRules"
                      :search-input.sync="search"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="dialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="create"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- end user -->

      <!-- user update modal-->
      <v-dialog
        v-model="updatedialog"
        max-width="600px"
        >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Update SubCategory</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      label="Sub Category Name*"
                      v-model="item.updatesubcategory_name"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    >
                    <v-autocomplete
                      :items="categories"
                      label="Select category"
                      v-model="item.updatecategory_id"
                      :value="item.updatecategory_id"
                      item-text="category_name"
                      item-value="id"
                      :rules="fieldRules"
                      :search-input.sync="search"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="updatedialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="update"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- update user -->

    </div>

</template>

<script>
import axios from 'axios'
import { Modal } from 'bootstrap'
import {ability} from '../../services/ability'

export default {
    name:"subCategoryList",
    data(){
        return {
          fieldRules: [
          (v) => !!v || 'Field is required'
          ],
          search:null,
          valid: true,
          searchrole:null,
          dialog: false,
          updatedialog: false,
          breadcrumbs: [
            {
              text: 'Dashboard',
              disabled: false,
              href: '/',
            },
            {
              text: 'Products',
              disabled: false,
              href: '',
            },
            {
              text: 'Sub Categories',
              disabled: false,
              href: '',
            },
          ],
          fields: [
             {
              text: '#',
              align: 'start',
              value: 'created_at',
            },
            { text: 'Sub Category', value: 'name' },
            { text: 'Category', value: 'category' },
            { text: 'Action', value: 'action' },
           ],
          item:{
                subcategory_name:"",
                category_id:"",
                updatesubcategory_name: "",
                updatecategory_id:"",
                updateID: "",
                _method:"patch"
            },
            loading: false,
           disabled: false,
           isBusy: false,
            updateModal: null
        }
    },
    beforeMount() {
      if(!ability.can('inventory-management', 'all')) {
        this.$router.push({ name: 'Pos' })
        return
      }
    },
    mounted(){
      // if(!this.subcategories || this.subcategories.length == 0) {
      //   this.getSubCategories()
      // }
      this.getSubCategories()
    },
    computed: {
      subcategories() {
        return this.$store.state.subcategories
      },
      categories() {
        return this.$store.state.categories
      },
    },
    methods:{
      async getSubCategories(){
        this.isBusy = true
        await axios.get('/sub-category').then(response=>{
            this.$store.state.subcategories = response.data.subcategories
            this.$store.state.categories = response.data.categories
        }).catch(error=>{
            console.log(error)
        })
      },
       async create(){

        if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('name',this.item.subcategory_name)
            fd.append('category_id',this.item.category_id)

            await axios.post('/sub-category', fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              if(response.data.status === parseInt(200))
                this.$toast.success("Sub Category added successfully",'Success',{position: 'topRight',timeout: 7000,})
                this.getSubCategories()
                this.clear()
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

        }

        },
        clear () {
          this.$refs.form.reset()
        },
        async update(){

          if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('name',this.item.updatesubcategory_name)
            fd.append('category_id',this.item.updatecategory_id)
            fd.append('_method',this.item._method)

            await axios.post(`/sub-category/${this.item.updateID}`, fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              if(response.data.status === parseInt(200))
                this.$toast.success("Sub Category updated successfully",'Success',{position: 'topRight',timeout: 7000,})
                this.updatedialog = false
                this.getCategories()
              this.clear()
              this.item.updateID = ''
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

          }

        },
      async edit(id) {
        let index = this.subcategories.filter(item => item.id === id );
        this.item.updatesubcategory_name = index[0].name
        this.item.updatecategory_id = index[0].category_id
        this.item.updateID = index[0].id
        this.updatedialog = true
      },
      async deleteq(id){
            if(confirm("Are you sure to delete sub category ?")){
                await axios.delete(`/sub-category/${id}`).then(response=>{
                  this.$toast.success('Sub Category deleted successfully','Success',{position: 'topRight',timeout: 7000,})
                    this.getCategories()
                }).catch(error=>{
                    console.log(error)
                })
            }
        }

    }
}
</script>